/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Kind_One_On_OnesInputs */



/**
* | output |
* | --- |
* | "1:1s with colleagues" |
*
* @param {Meetings_Kind_One_On_OnesInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_kind_one_on_ones = /** @type {((inputs?: Meetings_Kind_One_On_OnesInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Kind_One_On_OnesInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("1:1's met collega's")
	if (locale === "fr") return /** @type {LocalizedString} */ ("1:1 avec des collègues")
	return /** @type {LocalizedString} */ ("1:1s with colleagues")
});